import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Channel } from 'icreate/common/models/channel';
import { ChannelGroup } from 'icreate/common/models/channel-group';

class ChannelAndGroup extends Channel {
    group: ChannelGroup;
}

@Component({
    selector: 'app-system-integration-channel',
    templateUrl: './system-integration-channel.component.html',
    styleUrls: ['./system-integration-channel.component.css'],
    standalone: false,
})
export class SystemIntegrationChannelComponent {
    @Input() assignedChannel: ChannelAndGroup;
    @Input() removePadding: boolean = false;
    @Output() onOpenSelector: EventEmitter<void> = new EventEmitter();
    @Output() onRemoveChannel: EventEmitter<void> = new EventEmitter();

    openChannelSelector() {
        this.onOpenSelector.emit();
    }

    removeAssignedChannel() {
        this.onRemoveChannel.emit();
    }
}
